export default __webpack_public_path__ + "static/media/footer-m@3x.948afb1a.png";